import { GraphQLScalarType } from 'graphql';
import dayjs from '@/utils/dayjs';

export default new GraphQLScalarType({
  name: 'DateTime',
  serialize(value: dayjs.Dayjs | string): string {
    if (typeof value === 'string') return value;
    return value.toISOString();
  },
  parseValue(value: string): dayjs.Dayjs {
    return dayjs.utc(value).local();
  },
});
